import { AnimatePresence, motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTES } from '@/shared/config/routes';
import { cn } from '@/shared/lib';

import { NAV_LINKS } from './navLinks';

type MobileNavMenuProps = {
  open: boolean;
  /** Called after any link is followed, so the menu collapses on navigation. */
  onNavigate: () => void;
};

/** Collapsible navigation shown under the header below the md breakpoint. */
export const MobileNavMenu = ({ open, onNavigate }: MobileNavMenuProps) => {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          id="mobile-navigation"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="space-y-4 overflow-hidden border-b border-gray-100 bg-white px-4 pt-4 pb-6 shadow-lg md:hidden"
        >
          {NAV_LINKS.map(({ to, labelKey, emphasis }) => (
            <Link
              key={to}
              to={to}
              onClick={onNavigate}
              className={cn(
                'block py-2',
                emphasis ? 'font-bold text-primary' : 'font-medium text-gray-800',
              )}
            >
              {t(labelKey)}
            </Link>
          ))}

          <div className="flex flex-col space-y-3 border-t border-gray-100 pt-4">
            <Link
              to={ROUTES.auth}
              state={{ isLogin: true }}
              onClick={onNavigate}
              className="w-full rounded-xl border border-primary/20 py-3 text-center font-medium text-primary transition-colors hover:bg-primary/5"
            >
              {t('nav.login')}
            </Link>
            <Link
              to={ROUTES.auth}
              state={{ isLogin: false }}
              onClick={onNavigate}
              className="w-full rounded-xl bg-primary py-3 text-center font-medium text-white shadow-md"
            >
              {t('nav.createProfile')}
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
